import React, { useState } from "react";
import { api } from "../lib/api";
import { Bell, Mail } from "lucide-react";
import { toast } from "sonner";

export default function RestockButton({ itemId }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(`/items/${itemId}/restock-me`, { email });
      setDone(true);
      toast.success("You're on the list · Boggy will text you (well, email you) when one comes in");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Try again");
    } finally { setLoading(false); }
  };

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="brut-btn bg-pink text-white px-5 py-3 flex items-center gap-2"
        data-testid="restock-open-btn"
      >
        <Bell size={18} strokeWidth={3} /> Restock me
      </button>
    );
  }

  if (done) {
    return (
      <div className="brut bg-green p-4 max-w-md" data-testid="restock-done">
        <div className="font-display text-xl uppercase">You're on the list</div>
        <p className="text-sm mt-1">Boggy will email you the moment something similar comes in.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="brut p-4 bg-paper max-w-md flex flex-col gap-3" data-testid="restock-form">
      <div className="font-display text-xl uppercase flex items-center gap-2"><Bell size={18} strokeWidth={3} /> Tell me when this is back</div>
      <p className="text-sm">We'll email you when a similar piece (same size + style) lands.</p>
      <div className="brut-input flex items-center gap-2">
        <Mail size={16} strokeWidth={3} />
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="bg-transparent outline-none w-full" data-testid="restock-input" />
      </div>
      <div className="flex gap-2">
        <button disabled={loading} className="brut-btn bg-orange text-white px-4 py-2 flex-1" data-testid="restock-submit">{loading ? "…" : "Notify me"}</button>
        <button type="button" onClick={() => setOpen(false)} className="brut-btn bg-white px-3 py-2 text-sm">cancel</button>
      </div>
    </form>
  );
}
